import React from 'react';
import { FormControl, Select, MenuItem, Box, Switch } from '@mui/material';
import { useTranslation } from 'react-i18next';

import type { TriggerInterruption } from '@shared/interfaces/assistantScript';
import {
  TriggerSectionTitle,
  TriggerSectionSubtitle,
} from '../AssistantScriptDialog.styled';
import {
  InterruptSectionContainer,
  InterruptMenuItemRow,
  InterruptMenuItemTitle,
  InterruptMenuItemDescription,
  InterruptMenuPauseIcon,
  InterruptMenuStopIcon,
  InterruptMenuLockIcon,
  BridgeGapsBox,
  BridgeGapsTitle,
  BridgeGapsDescription,
} from './styled';

interface InterruptSectionProps {
  interruptMode: TriggerInterruption;
  onInterruptModeChange: (mode: TriggerInterruption) => void;
  bridgeRegionGaps: boolean;
  onBridgeRegionGapsChange: (bridge: boolean) => void;
}

const InterruptSection = ({
  interruptMode,
  onInterruptModeChange,
  bridgeRegionGaps,
  onBridgeRegionGapsChange,
}: InterruptSectionProps) => {
  const { t } = useTranslation('common');

  return (
    <InterruptSectionContainer>
      <TriggerSectionTitle>{t('assistant.scriptDialog.whenInterrupted')}</TriggerSectionTitle>
      <TriggerSectionSubtitle>
        {t('assistant.scriptDialog.whenInterruptedSubtitle')}
      </TriggerSectionSubtitle>
      <FormControl fullWidth size="small">
        <Select
          value={interruptMode}
          onChange={(e) =>
            onInterruptModeChange(e.target.value as TriggerInterruption)
          }
        >
          <MenuItem value="finish_step">
            <InterruptMenuItemRow>
              <InterruptMenuPauseIcon />
              <Box>
                <InterruptMenuItemTitle>
                  {t('assistant.scriptDialog.interruptFinishStep')}
                </InterruptMenuItemTitle>
                <InterruptMenuItemDescription>
                  {t('assistant.scriptDialog.interruptFinishStepDesc')}
                </InterruptMenuItemDescription>
              </Box>
            </InterruptMenuItemRow>
          </MenuItem>
          <MenuItem value="hard_cut">
            <InterruptMenuItemRow>
              <InterruptMenuStopIcon />
              <Box>
                <InterruptMenuItemTitle>
                  {t('assistant.scriptDialog.interruptHardCut')}
                </InterruptMenuItemTitle>
                <InterruptMenuItemDescription>
                  {t('assistant.scriptDialog.interruptHardCutDesc')}
                </InterruptMenuItemDescription>
              </Box>
            </InterruptMenuItemRow>
          </MenuItem>
          <MenuItem value="non_interruptible">
            <InterruptMenuItemRow>
              <InterruptMenuLockIcon />
              <Box>
                <InterruptMenuItemTitle>
                  {t('assistant.scriptDialog.interruptNonInterruptible')}
                </InterruptMenuItemTitle>
                <InterruptMenuItemDescription>
                  {t('assistant.scriptDialog.interruptNonInterruptibleDesc')}
                </InterruptMenuItemDescription>
              </Box>
            </InterruptMenuItemRow>
          </MenuItem>
        </Select>
      </FormControl>

      {interruptMode === 'finish_step' && (
        <BridgeGapsBox>
          <Switch
            checked={bridgeRegionGaps}
            onChange={(e) => onBridgeRegionGapsChange(e.target.checked)}
          />
          <Box>
            <BridgeGapsTitle>
              {t('assistant.scriptDialog.bridgeRegionGaps')}
            </BridgeGapsTitle>
            <BridgeGapsDescription>
              {t('assistant.scriptDialog.bridgeRegionGapsDesc')}
            </BridgeGapsDescription>
          </Box>
        </BridgeGapsBox>
      )}
    </InterruptSectionContainer>
  );
};

export default InterruptSection;
